
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Créer un site internet d’électricien – Exemples, Prix et Délais",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Si vous voulez devenir l’électricien à appeler en premier dans votre périmètre d’intervention, vous devez assurer d’excellentes prestations lors de vos interventions.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Créer un site internet d’électricien – Exemples, Prix et Délais",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Si vous voulez devenir l’électricien à appeler en premier dans votre périmètre d’intervention, vous devez assurer d’excellentes prestations lors de vos interventions.",
        },
      ],
    };
  },
};
